import styled from 'styled-components';

export const BankCodeWrapper = styled.div`
  margin-top: 1rem;
  margin-left: 3rem;
`;
